export function getWidgetEnabled(theme, lang) {
  if (!("fetch" in window)) {
    return;
  }

  return fetch(
    `${window.BH_URL}/api/widget-enabled?rootTheme=${theme}&theme=${theme}&lang=${lang}`
  );
}
